import React, { useState } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
} from "react-router-dom";
import './../styles/Footer.scss'
import sancologo from './../img/sankologo.png'
import electriciki from './../img/electriciki.png'
import eletricsale from './../img/electric-sale.png'

const Footer = () => {

  const lang = localStorage.getItem("lang");
  const [linksFirst, setLinksFirst] = useState([
    {
      "id": 1,
      "name": "Anasayfa",
      "link": "/",
      "name_en":"Homepage",
      "link_en":"#"
    },
    {
      "id": 2,
      "name": "Online İşlemler",
      "link": "https://musteriportal.sankoenerji.com.tr/Login/IndexDefault",
      "name_en":"Online Services",
      "link_en":"https://musteriportal.sankoenerji.com.tr/Login/IndexDefault"
    },
    {
      "id": 3,
      "name": "Hakkımızda",
      "link": "kurumsal/hakkimizda",
      "name_en":"About Us",
      "link_en":"en/corporate/about-us"
    },
    {
      "id": 4,
      "name": "Haberler",
      "link": "medya-merkezi/haberlerimiz",
      "name_en":"Our News",
      "link_en":"en/media-center/our-news"
    }
  ])
  const [linksSecond, setLinksSecond] = useState([
    {
      "id": 5,
      "name": "Sürdürülebilirlik",
      "link": "surdurulebilirlik/politikalarimiz",
      "name_en":"Sustainability",
      "link_en":"en/sustainability/Our-Policies"
    },
    {
      "id": 6,
      "name": "Faaliyet Raporları",
      "link": "yayinlar/faaliyet-raporlarimiz",
      "name_en":"Publications",
      "link_en":"en/publications/Other-Publications"
    },
    {
      "id": 7,
      "name": "Kariyer Fırsatları",
      "link": "kariyer/kariyer-firsatlari",
      "name_en":"Career",
      "link_en":"en/career/Our-Human-Resources-Policy"
    },
    {
      "id": 8,
      "name": "İletişim",
      "link": "iletisim",
      "name_en":"Contact",
      "link_en":"en/contact"
    }
  ])
  const [linksThird, setLinksThird] = useState([
    {
      "id": 9,
      "name": "Elektrik Üretimi",
      "link": "faaliyet-alanlari/elektrik-uretimi",
      "name_en":"Electricity Production",
      "link_en":"en/activities/electricity-production"
    },
    {
      "id": 10,
      "name": "Elektrik Ticareti",
      "link": "faaliyet-alanlari/elektrik-ticareti",
      "name_en":"Electricity Trading",
      "link_en":"en/activities/Electrcitiy-Trading"
    },
    {
      "id": 11,
      "name": "Elektrik Satışı",
      "link": "faaliyet-alanlari/elektrik-satisi",
      "name_en":"Electricity Sales",
      "link_en":"en/activities/Electricity-Sales"
    },
  ])



  return (
    <footer>
      <div className="footer-inside-container ">
        <div className="footer-icon-container">
          <Link to="/">
            <img src={sancologo} alt="logo" />
          </Link>
          <div className="footer-icon-div">
            <ul>
              <li>
                <a href="https://twitter.com/Sanko_Enerji" target="blank">
                  <i className="fab fa-twitter footer-social-media-icon"></i>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/sanko-enerji/" target="blank">
                  <i className="fab fa-linkedin footer-social-media-icon"></i>
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/sankoenergy/" target="blank">
                  <i className="fab fa-facebook-square footer-social-media-icon"></i>
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UCSZSxCQi338RlyzE2qrWAKQ" target="blank">
                  <i className="fab fa-youtube homepage-social-media-icon"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/sankoenerji/" target="blank">
                  <i className="fab fa-instagram footer-social-media-icon"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="electrik-sale-img">
          <img src={lang=="en" ? eletricsale : electriciki} alt="sale" />
        </div>
        <div className="footer-contact">
          <ul>
            {linksFirst ?
              linksFirst.map((link) => (
                
                lang == "en"? (
                link.id == "2" ?
                  (
                    <li key={link.id}>
                      <a href={link.link_en} target="_blank">
                        {link.name_en}
                      </a>
                    </li>
                  )
                  :
                  (
                    <li key={link.id}>
                      <Link to={"/" + link.link_en}>
                        {link.name_en}
                      </Link>
                    </li>
                  )

                  ):(

                    link.id == "2" ?
                    (
                      <li key={link.id}>
                        <a href={link.link} target="_blank">
                          {link.name}
                        </a>
                      </li>
                    )
                    :
                    (
                      <li key={link.id}>
                        <Link to={"/" + link.link}>
                          {link.name}
                        </Link>
                      </li>
                    )
                    
                  )


              ))
              : null}
          </ul>
          <ul>
            {linksSecond ?
              linksSecond.map((link) => {
                return (
                  lang == "en" ? (
                  <li key={link.id}>
                    <Link to={"/" + link.link_en}>
                      {link.name_en}
                    </Link>
                  </li>
                  ):(
                    <li key={link.id}>
                    <Link to={"/" + link.link}>
                      {link.name}
                    </Link>
                  </li>
                  )
                )
              })
              : null}
          </ul>
          <ul>
            {linksThird ?
              linksThird.map((link) => {
                return (
                  lang == "en" ? (
                    <li key={link.id}>
                      <Link to={"/" + link.link_en}>
                        {link.name_en}
                      </Link>
                    </li>
                    ):(
                      <li key={link.id}>
                      <Link to={"/" + link.link}>
                        {link.name}
                      </Link>
                    </li>
                    )
                )
              })
              : null}
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default Footer
